import api from "../api";
import {iniciarRequisicao} from '../../helpers/index';

class TempoCoberturaPorFornecedor {
  async getListaFull(headers) {
    const response = await api.get("/compras/tempo-cobertura-curvas-fn", { headers });
    return response;
  }

  async deleteMultiplos(headers, params) {
    const response = await api({
      method: 'delete',
      url: `/compras-delete-multiplos-tempo-cobertura-fornecedor`,
      headers,
      data: params
    });
    return response;
  }

  async store(headers, params) {
    const response = await api({
      method: 'post',
      url: 'compras/tempo-cobertura-curvas-fn',
      headers,
      data: params
    });
    return response;
  }

  async registrarTemposCoberturaFornecedorFilial(headers, params) {
    const response = await api({
      method: 'post',
      url: 'compras/tempo-cobertura-curvas-fn/registrar-tempos-cobertura-fornecedor-filial',
      headers,
      data: params
    });
    return response;
  }

  async aplicarTempoCobertura(params) {
    const headers = iniciarRequisicao();

    const response = await api({
      method: 'post',
      url: '/compras/tempo-cobertura-curvas-fn/aplica-em-produtos',
      headers,
      data: params
    });
    return response;
  }
}

export default new TempoCoberturaPorFornecedor();
